export const korean = {
  translation: {
    // ================================= titles =================================
    titles: {
      popular_add_ons: '인기 추가 기능',
      top: '상단',
      hello: '안녕하세요',
      in_your_cart: '장바구니',
      search_result: '에 대한 결과',
      no_items_found: '0개 항목을 찾았습니다.',
      search_empty: '표시할 결과가 없습니다',
      call_staff: '고객님의 전화를 받았습니다',
      sub_total: '소계',
      total: '합계',
      order_details: '주문 내역',
      order_history: '주문 내역',
      popup_pay: '결제할 준비가 되었습니까?',
      payment_success: '지불 요청을 받았습니다.',
      order_empty: '주문함이 비어 있습니다',
      pending: '보류 중',
      served: '배달 되었습니다',
      confirmed: '배달 되었습니다',
      finish_cooking: '조리 완료',
      cancelled: '취소되었습니다',
      ready_to_order: '주문할 준비가 되셨나요?',
      order_success: '주문을 받았습니다.',
      maxQuantityPerOrder: '1주문당 최대 주문가능 개수',
      topping_type_quantity: '{{min}} 이상-{{max}} 이하',
      menu_excludes_vat: '이 가격에는 부가세가 포함되어 있지 않습니다.',
      rescanQR: 'QR코드를 다시 스캔하여 주문하세요.',
      choose_language_to_start: '언어를 선택하세요',
      extraFee: '추가 비용',
      discountAmount: '할인',
      customizedService: '맞춤형 서비스',
      selectOption: '옵션을 선택하세요',
      call_staff_reasons: '직원 호출',
      choose_payment_method: '결제수단',
      payment_successfully: '결제 성공',
      payment_failed: '결제실패',
      how_was_your_experience: '식사와 서비스는 어떠셨나요?',
      your_details: '요청사항',
      how_many_people: '몇 명이세요?',
      please_select_number_of_people: '*유아를 포함한 인원수를 선택해 주세요.',
      choose_number_of_people: '오늘 귀하의 테이블에 있는 인원수를 선택하십시오:',
      buffet: '뷔페',
      order_placed: '주문 완료!',
      order_code: '주문 코드',
      review_order: '리뷰를 작성해주세요',
      popular: '인기',
      hope_you_enjoyed: '즐거운 경험이셨기를 바랍니다',
      review_success: '감사합니다!',
      popup_food_error_order:
        '<span style="font-weight:{{fontWeight}}">{{nameFood}}</span> 요리가 품절되었습니다!',
      popup_topping_error_order:
        'The topping <span style="font-weight:{{fontWeight}}">{{nameTopping}}</span> out of stock!',
      input_a_name: '이름을 입력해주세요',
      input_a_phone: '전화번호를 입력하세요',
      why_we_need_it: '이름을 기재하는 이유',
      discount: '할인',
      // tablet
      search: '검색',
      call_staff_tablet: '콜스태프',
      bill: '청구서',
      pay: '지불하다',
      table_number: '테이블 번호:',
      ask_for_bill: '청구서 요청',
      ask_for_bill_decription: '“청구서 요청”을 탭하여 계산서를 가져오십시오.',
      not_yet: '아직',
      quantity: '수량',
      item_table: '상품',
      status_table: '상태',
      price_table: '가격',
      other: '다른',
    },
    // ================================= descriptions =================================
    descriptions: {
      reached_end: '페이지 맨 끝',
      cart_empty: '장바구니가 비어 있습니다',
      hint_cart_empty: '메뉴를 보려면 여기를 클릭하세요.',
      search_empty: '맞춤법을 확인하거나 다른 검색어를 사용해 보세요.',
      call_staff: '곧 배달 드릴 예정입니다. 기다려 주셔서 감사합니다.',
      popup_pay: "'청구서 요청'을 탭하면 청구서를 가져다 드릴 수 있습니다.",
      payment_success: '곧 배달 드릴 예정입니다. 기다려 주셔서 감사합니다.',
      restaurant_on_capichi: '<span style="color:{{colorText}}">카피치</span>와 함께합니다',
      order_empty: '원하는 요리를 선택하여 주문에 추가합니다.',
      orderNotFound: '주문을 찾을 수 없습니다!',
      order_success: '주문이 접수되어 지금 처리중입니다. 조금만 기다려 주시면 감사하겠습니다.',
      rescanQR:
        '죄송합니다. 이전 주문이 만료되었습니다. 해당 레스토랑에서 주문하려면 QR 코드를 다시 스캔해주세요.',
      // new
      order_food_and_drink: '원하는 시간에 음식과 음료를 주문하세요',
      seek_for_help: '온라인으로 직접 직원에게 도움을 요청하십시오',
      ask_to_pay: '식사를 마치고 나면 지불을 요청하십시오',
      or_ask_directly: '직접 문의하기',
      haveVAT: '{{vatRate}}% 부가세 불포함',
      haveServiceFee: '{{serviceRate}}% 의 서비스 요금이 부과됩니다',
      popup_payment_success:
        '결제가 승인되었습니다. 카피치를 이용해주셔서 감사합니다. 고객님 ,좋은 하루 되시길 바랍니다.',
      popup_payment_failed:
        '결제승인이 실패했습니다. 잠시 후 재시도 하시거나 다른 결제방법을 이용해주세요.',
      tap_to_save_screen: '매장 직원에게 이 화면을 보여주세요.',
      checkouted_order: `오늘도 카피치 어플을 사용해주셔서 감사합니다. 편리하고 빠르게 주문하실 수 있도록 노력하겠습니다.
      오늘도 카피치 어플을 사용해주셔서 감사합니다. 편리하고 빠르게 주문하실 수 있도록 노력하겠습니다.`,
      review_success:
        '고객님의 리뷰가 접수되었으며 더 발전할 수 있는 카피치가 될수 있도록 고객님의 리뷰를 검토겠습니다. 시간을 할애해주셔서 감사합니다',
      input_a_name:
        '귀하는 현재 다른 주문이 포함된 테이블에서 주문하고 있습니다. 주문이 구분될 수 있도록 주문을 식별할 수 있는 간단한 이름*을 입력해주세요',
      input_a_phone:
        '귀하의 주문을 접수한 이후에, 주문 트랙킹 메시지를 보내기 위해 귀하의 전화번호가 필요합니다.',
      min_left: '하기 메뉴에서 {{min_left}}분 동안 뷔페 주문이 가능합니다',
    },

    // ================================= actions =================================
    actions: {
      call_staff: '직원 호출',
      pay: '지불',
      back_to_top: '맨 위로 올라가기',
      order: '주문',
      go_back: '돌아가기',
      see_menu: '메뉴 보기',
      order_now: '지금 주문',
      clear_all: '모두 지우기',
      search_again: '다시 검색',
      retry: '재시도',
      back_to_menu: '메뉴로 돌아가기',
      ask_for_bill: '청구서 요청',
      not_yet: '아직',
      discover: '발견',
      delete_dish: '삭제',
      noteFood: '특별한 요청사항 등을 추가합니다',
      addToCart: '장바구니에 담기',
      addNote: '메모',
      confirmOrder: '주문',
      // new
      start_ordering: '주문 시작',
      pay_online: '온라인 결제',
      send: '보내기',
      try_again: '다시 시도해주세요',
      call_staff_for_help: '직원을 호출해주세요',
      skip: '건너뛰기',
      next: '확인',
      done: '종료',
      confirm: '확인',
      order_from_here: '지금 주문하기',
      tap_to_save_screen: '탭하여 화면 저장',
      see_a_menu: '메뉴 확인하기',
      update: '업데이트',
      cancel: '취소',
      add: '추가',
      ok: 'OK',
      see_the_time: '시간 확인하기',
    },
    // ================================= errors =================================
    errors: {
      server_error: '서버에 연결할 수 없습니다',
      errorOutOfStock: '죄송합니다. 이 상품은 품절되었습니다. 다른 상품을 주문해 주세요.',
      errorQuantityPerOrder: '선택하신 요리의 개수가 최대 개수를 초과했습니다. 다시 선택해 주세요.',
      errorQuantityExceeded: '죄송합니다, 재고가 부족합니다. 수량을 변경해 주세요.',
      somethingWrong: '알수없는 오류가 있습니다. 다시 시도해 주세요.',
      errorFoodHasChanged:
        '죄송합니다. 해당 매장에서 상품 정보를 갱신하였으니 다시 주문 부탁드립니다.',
      warningMin: '이 토핑은 {{min}}개 이상 선택하셔야 합니다',
      warningMax: '이 토핑은 최대 {{max}}개 까지만 선택하실 수 없습니다',
      notFoundFoodItem:
        '죄송합니다. 레스토랑에서 일시적으로 이 요리를 제공하지 않습니다. 나중에 다시 시도 해주십시오.',
      errorNotOpenTable: '주문이 정상적으로 처리되지 않았습니다. 매장 직원을 호출해주세요',
      max_comment_review: '{{max}}자 이내',
      payment_method_changed: '결제 방법이 변경되었습니다.',
      payment_method_changed_desc: '페이지를 새로고침 해주시고 결제 방법을 다시 선택해주세요.',
      max_characters: '{{max}}자 이내로 ',
      required_floor: '층수를 선택해 주세요',
      required_room: '호수를 선택해 주세요',
      required_full_name: '성함',
      errorOutOfStockNEC: '품절',
      rating_already_existed: '죄송합니다. 이 주문은 이미 검토되었습니다.',
      voucher_not_suitable: '입력이 불가능한 바우처 코드 입니다. 다시 시도해 주세요',
      error: '에러 ',
      voucher_not_found: '바우처 코드가 존재하지 않습니다. 다른 코드를 입력해 보세요.',
      voucher_outside_time_period:
        '바우처 코드가 유효하지 않거나 만료되었습니다. 다른 코드를 입력해 보세요.',
      voucher_just_apply_for_restaurants:
        '바우처 코드는 이 곳에만 적용 가능합니다: {{restaurants}}',
      voucher_min_order_value: '바우처 코드는 {{min_order_value}} 주문시 적용 가능합니다.',
      voucher_has_been_used: '바우처 코드가 사용되었습니다',
      voucher_out_of_quantity: '이 프로모션 코드는 만료되었습니다. 다른 코드를 입력해 주세요.',
      min_max_phone_number: '{{min}}~{{max}}자 사이의 전화번호를 입력하세요.',
    },

    languages: {},
    // ================================= label =================================
    label: {
      required: '요청',
      optional: '선택',
      my_cart: '장바구니',
      items_found: '항목을 찾았습니다.',
      sold_out: '매진',
      items: '항목',
      powered_by: '제공자',
      vat: '부가세',
      service_fee: '서비스 요금',
      your_order: '주문',
      or: '또는',
      payment_methods: {
        international_card: '신용카드',
        atm: 'ATM 카드',
        qr_code: 'QR 송금',
        e_wallet: '전자지갑',
      },
      review_or_comment: '리뷰를 남겨주세요',
      only_letters: '문자만 기입 가능',
      buffet: '부페',
      min_left: '<strong style="color:{{color}}">{{min_left}}</strong>분 한정',
      all_you_can_drink: '음료 무제한',
    },
    // ================================= placeholder =================================
    placeholder: {
      input_search: '요리, 메뉴, 음료 검색...',
      choose_your_floor: '층수',
      choose_your_room: '룸',
      your_full_name: '성함',
      no_results: '찾을 수 없습니다',
      your_name: '이름',
      enter_voucher_code: '바우쳐 코드 입력',
      your_phone: '전화번호 입력',
    },
    popup_start_buffet: {
      course_menu_has_started: '코스 메뉴가 시작되었습니다.',
      time_limit: '시간 제한',
      time_value: '{{value}}분',
      see_menu: '메뉴 보기',
    },
    popup_add_friend_line: {
      line: 'LINE',
      description: '모바일 주문 서비스를 이용하려면 LINE 친구로 추가해주세요.',
      add_friend_btn: 'LINE 친구로 추가하기',
      already_added: '이미 친구로 추가됨',
    },
  },
}
